var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAmarillo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68535 3.18535V1.31465H5.81862L4.49206 0L3.18535 1.31465H1.31465V3.18535L0 4.49206L1.31465 5.81862V7.68535H3.18535L4.49206 9L5.81862 7.68535H7.68535V5.81862L9 4.49206L7.68535 3.18535ZM3.23301 2.52604C3.62224 2.52604 3.93601 2.83981 3.93601 3.23301C3.93601 3.41946 3.86194 3.59827 3.73011 3.73011C3.59827 3.86194 3.41946 3.93601 3.23301 3.93601C2.83981 3.93601 2.52604 3.62224 2.52604 3.23301C2.52604 2.83981 2.83981 2.52604 3.23301 2.52604ZM5.77096 6.47793C5.38173 6.47793 5.06796 6.16019 5.06796 5.77096C5.06796 5.58452 5.14203 5.4057 5.27387 5.27387C5.4057 5.14203 5.58452 5.06796 5.77096 5.06796C6.16019 5.06796 6.47793 5.38173 6.47793 5.77096C6.47793 5.95846 6.40345 6.13828 6.27087 6.27087C6.13828 6.40345 5.95846 6.47793 5.77096 6.47793ZM3.10194 6.48985L2.50618 5.89409L5.89409 2.50618L6.48985 3.10194L3.10194 6.48985Z",
    fill: "#E7BA07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAmarillo);
export default __webpack_public_path__ + "static/media/checkAmarillo.bfd07b117f8c3788c5f0de541ab5f016.svg";
export { ForwardRef as ReactComponent };